import template from './entitiesMultipleSelector.html';
import './entitiesMultipleSelector.scss';

export class EntitiesMultipleSelectorController {
  constructor($element, $timeout) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$timeout = $timeout;
    this.showAllPills = false;
    this._searchboxSelector = '[data-selector-searchbox] input[type="text"]';
  }
  $onChanges(changes) {
    if (
      changes.loading &&
      changes.loading.previousValue &&
      !changes.loading.currentValue
    ) {
      this.setSearchboxFocus();
    }
  }
  setSearchboxFocus() {
    this.$timeout(() => {
      this.$element.querySelector(this._searchboxSelector).focus();
    });
  }
  search(text) {
    this.onSearch({ text });
  }
  isSelected(item) {
    return this.selections.find((selection) => selection.id === item.id);
  }
  toggleSelection(item) {
    this.onSelectionToggle({
      item,
      isSelected: this.isSelected(item),
    });
  }
  onTogglePillsVisibility() {
    this.showAllPills = !this.showAllPills;
  }
  removePill(pill) {
    this.onSelectionToggle({
      item: pill,
      isSelected: true,
    });
  }
}

export default {
  controller: EntitiesMultipleSelectorController,
  template,
  bindings: {
    id: '@',
    placeholderText: '@',
    loading: '<',
    results: '<',
    selections: '<',
    onSearch: '&',
    onSelectionToggle: '&',
  },
};
